import { Skeleton, Grid } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import { Chip } from "@mui/material";
import clsx from "clsx";
const useStyle = makeStyles((theme) => ({
  rsChipStyleMain: {
    border: "3 solid",
    borderRadius: "10px ",
    fontSize: "10px !important",
    height: "20px !important",
    marginLeft: "3px !important",
    marginRight: "3px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "white",
    display: "flex",
    alignItems: "center",
    "&>span": {
      fontSize: "10px",
      padding: "8px 8px",
      fontWeight: "600 !important",
      zIndex: "12 !important",
    },
    [theme.breakpoints.down(1500)]: {
      marginLeft: "0 !important",
      marginTop: "3px",
    },
  },
  rsChipStyle: {
    border: "3 solid",
    borderRadius: "10px ",
    fontSize: "10px !important",
    height: "20px !important",
    marginLeft: "3px !important",
    marginRight: "3px",
    // marginTop: "8px",
    // marginBottom: "8px",
    color: "white",
    display: "flex",
    alignItems: "center",
    "&>span": {
      fontSize: "10px",
      padding: "8px 8px",
      fontWeight: "600 !important",
      zIndex: "12 !important",
    },
    [theme.breakpoints.down(1500)]: {
      marginLeft: "0 !important",
      marginTop: "3px",
    },
  },
}));
/** default click function */
const defaultFunction = () => {};
/** default onchange function */
const defaultOnChange = () => {};
const Chips = ({
  label,
  color = "rgba(107, 107, 107,0.6)",
  key,
  variant = "filled",
  borderColorChip = "rgba(107, 107, 107,0.6)",
  textColor = "white",
  border = "3",
  width = "auto",
  className,
  rippleEffectEnabled,
  click,
  onChange = defaultOnChange,
  onClick = defaultFunction,
}) => {
  const classes = useStyle();
  return (
    <Chip
      key={key}
      variant={variant}
      className={clsx(
        click ? classes.rsChipStyle : classes.rsChipStyleMain,
        className
      )}
      label={label}
      disableRipple={rippleEffectEnabled}
      style={{
        background: color,
        borderColor: borderColorChip,
        color: textColor,
        border: border,
        width: width,
      }}
      onClick={click ? null : (e) => onClick(e)}
      // onClick={(e) => onClick(e)}
      onChange={(e) => onChange(e)}
    />
  );
};

export default Chips;
